import { render, staticRenderFns } from "./VantFieldDate.vue?vue&type=template&id=a915eb30"
import script from "./VantFieldDate.vue?vue&type=script&lang=js"
export * from "./VantFieldDate.vue?vue&type=script&lang=js"
import style0 from "./VantFieldDate.vue?vue&type=style&index=0&id=a915eb30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports